import { Route, Routes } from "react-router";
import Complete from "./sections/Complete";
import Emotions from "./sections/Emotions";
import EmpathyAccuracy from "./sections/EmpathyAccuracy";
import EmpathyCompassion from "./sections/EmpathyCompassion";
import Introduction from "./sections/Introduction";
import LiaErrorBoundary from "../../components/LiaErrorBoundary";
import PositiveNegative from "./sections/PositiveNegative";
import PrintReport from "./sections/PrintReport";
import RelationshipStrategies from "./sections/RelationshipStrategies";
import Report from "./Report";
import ReportProvider from "./ReportContext";
import SelfOther from "./sections/SelfOther"
import Summary from "./sections/Summary";
import ThoughtsFeelings from "./sections/ThoughtsFeelings";

const ReportRoutes = () => (
	<ReportProvider>
		<LiaErrorBoundary>
			<Routes>
				<Route element={<Report />} path="/">
					<Route element={<Introduction />} path="/introduction" />
					<Route element={<Emotions />} path="/emotions" />
					<Route element={<PositiveNegative />} path="/positive-negative" />
					<Route element={<SelfOther />} path="/self-other" />
					<Route element={<ThoughtsFeelings />} path="/thoughts-wants-feelings" />
					<Route element={<EmpathyAccuracy />} path="/empathy-accuracy" />
					<Route element={<EmpathyCompassion />} path="/empathy-compassion" />
					<Route element={<RelationshipStrategies />} path="/relationship-strategies" />
					<Route element={<Summary />} path="/summary" />
					<Route element={<Complete />} path="/complete" />
					<Route element={<PrintReport />} path="/print" />
				</Route>
			</Routes>
		</LiaErrorBoundary>
	</ReportProvider>
);

export default ReportRoutes;
